import { isEqual } from 'lodash';
import { atom, SetStateAction } from 'jotai';
import { atomWithDefault, RESET } from 'jotai/utils';
import { mapURLSearchParamsToBulkProvisioningFilers } from '@/activityLog/bulkProvisioning/Filters/utils/filtersToURLSearchParamsMapper';
import { createPaginationAtoms } from './utils/filtersFactory';
import { focusAtom } from 'jotai-optics';
import { ProvisioningStatusFilter } from '@/activityLog/bulkProvisioning/constants/provisioningStatus';
import { ProvisioningSourceFilter } from '@/activityLog/bulkProvisioning/constants/provisioningSource';

export const { rowsPerPageFilterAtom, pageFilterAtom } = createPaginationAtoms();

export type BulkProvisioningFilters = {
  fileName: string;
  status: ProvisioningStatusFilter;
  orderNumber: string;
  uploadDateFrom: Date | null;
  uploadDateTo: Date | null;
  source: ProvisioningSourceFilter;
};

export const BULK_PROVISIONING_INITIAL_VALUES: BulkProvisioningFilters = {
  fileName: '',
  status: '',
  orderNumber: '',
  uploadDateFrom: null,
  uploadDateTo: null,
  source: [],
};

const filtersAtom = atomWithDefault(() => {
  const params = new URLSearchParams(globalThis.location.search);
  const filtersFromURL = mapURLSearchParamsToBulkProvisioningFilers(params);

  return {
    ...filtersFromURL,
    status: filtersFromURL.status,
    source: filtersFromURL.source,
  } as BulkProvisioningFilters;
});

export const bulkProvisioningFiltersAtom = atom(
  (get) => get(filtersAtom),
  (get, set, filters: SetStateAction<BulkProvisioningFilters> | typeof RESET) => {
    const currentSimFilters = get(filtersAtom);
    if (!isEqual(currentSimFilters, filters)) {
      set(pageFilterAtom, 0);
    }
    if (filters === RESET) {
      return set(filtersAtom, { ...BULK_PROVISIONING_INITIAL_VALUES });
    }

    return set(filtersAtom, filters);
  },
);

export const fileNameFilterAtom = focusAtom(bulkProvisioningFiltersAtom, (optic) =>
  optic.prop('fileName'),
);
